import "./SkeletonCard.scss";

interface SkeletonCardProps {
    indexKey: number;
}

export default function SkeletonCard({ indexKey }: SkeletonCardProps) {
    return (
        <div className="skeleton-card" key={indexKey}>
            <div className="skeleton-header">
                <div className="skeleton-title"></div>
                <div className="skeleton-menu"></div>
            </div>
            <div className="skeleton-preview"></div>
            <div className="skeleton-footer">
                <div className="skeleton-date"></div>
            </div>
        </div>
    );
}
